import React from "react";
import { SimpleGrid, Stack, Text } from "@mantine/core";
import { FormTemplate } from "../../types/formTemplates";
import { TemplateCard } from "./TemplateCard";

interface CustomTemplatesGridProps {
  templates: FormTemplate[];
  selectedId: string | null;
  onSelect: (template: FormTemplate) => void;
}

export const CustomTemplatesGrid: React.FC<CustomTemplatesGridProps> = ({
  templates,
  selectedId,
  onSelect,
}) => {
  if (templates.length === 0) {
    return (
      <Stack align="center" py="xl" gap={4}>
        <Text fw={600} size="sm">
          No custom templates yet
        </Text>
        <Text size="xs" c="dimmed">
          Click Create New Template to build one.
        </Text>
      </Stack>
    );
  }

  return (
    <SimpleGrid cols={{ base: 1, md: 2 }} spacing="md">
      {templates.map((template) => (
        <TemplateCard
          key={template.id}
          template={template}
          selected={selectedId === template.id}
          onClick={() => onSelect(template)}
        />
      ))}
    </SimpleGrid>
  );
};
